import { ManifestSalutation } from './types';

import type { Manifest, ManifestOption } from './types';
import type { OptionHTMLAttributes } from 'react';

export const mapManifestOptionsToHtmlOptions = (
  options?: ManifestOption[],
): OptionHTMLAttributes<HTMLOptionElement>[] =>
  options?.map(({ value, label }) => ({
    value: value,
    children: label,
  })) ?? [];

/** True when the traveller can select the salutation themselves: the manifest
 *  is not completed yet and the backend salutation options contain no adult
 *  entry ("Herr"/"Frau") */
export const isSalutationSelectable = (manifest?: Manifest): boolean => {
  if (manifest?.completed === true) return false;

  const options = manifest?.manifestOptions?.personalInfo?.salutationOptions;
  if (!options?.length) return false;

  return !options.some(
    o =>
      o.value === ManifestSalutation.HERR.valueOf() ||
      o.value === ManifestSalutation.FRAU.valueOf(),
  );
};

/** Backend stores phone numbers with a leading "00" international prefix.
 *  Convert to the "+CC …" form the form / PhoneNumberInput expects. */
export const phoneFromApi = (number: string | null | undefined): string => {
  if (!number) return '';
  if (number.startsWith('00')) return '+' + number.slice(2);
  return number;
};

/** Form state uses "+CC …". Convert to the "00CC…" form the backend stores
 *  Returns `null` for empty input, matching the existing sanitize semantics. */
export const phoneToApi = (
  formValue: string | null | undefined,
): string | null => {
  if (!formValue) return null;
  const compact = formValue.replace(/\s+/g, '');
  if (!compact) return null;
  if (compact.startsWith('+')) return '00' + compact.slice(1);
  return compact;
};
